var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileShield = function SvgFileShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 3h-7.8c-2.52 0-3.78 0-4.743.49A4.5 4.5 0 0 0 6.49 5.457C6 6.42 6 7.68 6 10.2v15.6c0 2.52 0 3.78.49 4.743a4.5 4.5 0 0 0 1.967 1.967C9.42 33 10.68 33 13.2 33h9.6c2.52 0 3.78 0 4.743-.49a4.5 4.5 0 0 0 1.967-1.967C30 29.58 30 28.32 30 25.8V12m-9-9 9 9m-9-9v9h9M18 27s4.5-2.145 4.5-5.362v-3.754l-3.281-1.172a3.62 3.62 0 0 0-2.44 0L13.5 17.884v3.754C13.5 24.855 18 27 18 27"
  })));
};
export default SvgFileShield;